export const bookList = [
  { key: "ehlel", label: "Эхлэл" },
  { key: "ilchlelt", label: "Илчлэлт" },
  { key: "uils", label: "Үйлс" },
  { key: "", label: "Тун удахгүй..." },
];
